// extracted by mini-css-extract-plugin
module.exports = {"subsection":"subsection_subsection__7oKKb"};